exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".login-buttons-external-logins-7k6SBxWEmwr{margin:40px 0 32px 0}@media (max-width: 1100px){.login-buttons-external-logins-7k6SBxWEmwr{margin:32px 0 20px 0}}.login-buttons-external-logins-7k6SBxWEmwr>div{display:flex}.login-buttons-external-logins-7k6SBxWEmwr>div>:last-child{margin-left:10px}.login-buttons-external-logins-7k6SBxWEmwr>*{margin-top:10px}.login-buttons-external-logins-7k6SBxWEmwr>*:first-child{margin-top:0}.login-buttons-field-3aOIaJwgmwr{font-weight:normal;width:100%}.login-buttons-darkblue-5ThfvPIHmwr{background-color:#0A416E}.login-buttons-padding-left-m-5TjVd20lmwr{padding-left:16px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"external-logins": "login-buttons-external-logins-7k6SBxWEmwr",
	"externalLogins": "login-buttons-external-logins-7k6SBxWEmwr",
	"field": "login-buttons-field-3aOIaJwgmwr",
	"darkblue": "login-buttons-darkblue-5ThfvPIHmwr",
	"padding-left-m": "login-buttons-padding-left-m-5TjVd20lmwr",
	"paddingLeftM": "login-buttons-padding-left-m-5TjVd20lmwr"
};